import React, { useEffect, useState, useContext } from "react";
import ItemRequestForm from "../ItemRequestForm";
import { toast } from "react-toastify";
import Layout from "components/sales/layout/layout";
import { BaseUrl } from 'contexts/baseUrl/baseUrl';

const CreateBusinessItem = ({ createItemRequest, getDropdownData, dropdownData, fetchBrandAndHsn, brandAndHsnData }) => {

  const [isLoading, setIsLoading] = useState(false);
  const { baseUrl } = useContext(BaseUrl);

  const [formData, setFormData] = useState({
    name: "",
    class_of_material: "",
    brand: "",
    description: "",
    type: "",
    base_unit_of_measure: "",
    qc_enable: "",
    qr_code: 0,
    tag: 0,
    item_category_code: "",
    unit_cost: "",
    gen_prod_posting_group: "",
    inventory_posting_group: "",
    unit_price: "",
    gst_group_code: "",
    hsn_sac_code: "",
    item_tracking_code: "",
    serial_no: "",
    unit_volume: "",
    net_weight: "",
    gross_weight: "",
    revenue_type: "",
  });

  useEffect(() => {
    getDropdownData();
  }, [getDropdownData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value.id,
    }));
  };

  useEffect(() => {
    if (!formData.type) return;
    setFormData((prev) => ({
      ...prev,
      inventory_posting_group: "",
    }));
  }, [formData.type]);

  useEffect(() => {
    if (!formData.serial_no) return;
    setFormData((prev) => ({
      ...prev,
      qr_code: 1,
    }));
  }, [formData.serial_no]);

  useEffect(() => {
    const fetchHsn = async () => {
      if (!formData.gst_group_code) return;
      setIsLoading(true);
      try {
        await fetchBrandAndHsn("gst", formData.gst_group_code, null);
        setFormData((prev) => ({
          ...prev,
          hsn_sac_code: null,
        }));
      } catch (error) {
        console.error("Error fetching HSN:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchHsn();
  }, [formData.gst_group_code]);

  useEffect(() => {
    if (!formData.item_category_code) return;

    setIsLoading(true);

    if (formData.item_category_code == 9 && formData.type !== 'Service') {
      setFormData((prev) => ({
        ...prev,
        tag: 1,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        tag: 0,
      }));
    }

    setIsLoading(false);
  }, [formData.item_category_code, formData.type]);

  useEffect(() => {
    if (formData.item_tracking_code == 'QR') {
      setFormData((prev) => ({
        ...prev,
        serial_no: 'QR SERIAL',
      }));
    }
  }, [formData.item_tracking_code]);

  useEffect(() => {
    setFormData((prev) => {
      if (prev.type === 'Service') {
        return { ...prev, class_of_material: 4 };
      }

      return prev;
    });
  }, [formData.type]);

  const handleSubmit = async () => {
    try {

      if (!formData?.name || !formData?.base_unit_of_measure || !formData?.unit_cost
        || !formData?.class_of_material || !formData?.type || !formData?.gst_group_code || !formData?.hsn_sac_code || (formData?.type != 'Service' && (!formData?.brand || !formData?.item_category_code))) {
        toast.error("Please fill all mandatory fields");
        return;
      }

      if (formData?.type != 'Service' && formData?.class_of_material == 4) {
        toast.error("Invalid Type and Class of Material combination");
        return;
      }

      const payload = {
        ...formData,
      };

      setIsLoading(true);

      const res = await createItemRequest(payload);
      if (res?.data?.status === true) {
        toast.success(res?.data?.message || "Item created successfully!");
        setTimeout(() => {
          if (formData?.type != 'Service') {
            window.location.href = `${baseUrl}/procurement/business-materials`;
          }
          else {
            window.location.href = `${baseUrl}/procurement/business-services`;
          }
        }, 1000);
      } else {
        toast.error(res?.data?.message || "Failed to create request");
      }
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Layout title={'Create Item'} isLoading={isLoading} isGoback={true}>
      <ItemRequestForm
        formData={formData}
        handleInputChange={handleInputChange}
        handleSubmit={handleSubmit}
        dropdownData={dropdownData}
        brandAndHsnData={brandAndHsnData}
        setFormData={setFormData}
        isLoading={isLoading}
        isEdit={false}
      />
    </Layout>
  );
};

export default CreateBusinessItem;
